import request from "../../../utils/request";

export const getHospital = '/hospital/'
export const exportHospital = '/hospital/export'

export function getHospitalList() {
    return request.request({
        url: '/hospital/',
        method: "get",
    })
}

export function modifyHospital(values: any) {
    debugger
    return request.request({
        url: '/hospital/',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function getHospitalDetail(id: any) {
    return request.request({
        url: '/hospital/detail/',
        method: "get",
        params: {id: id}
    })
}

export function switchHospital(id: any) {
    return request.request({
        url: '/hospital/switchStatus',
        method: "get",
        params: {id: id}
    })
}

export function importHospital(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return request.request({
        url: '/hospital/import',
        method: 'post',
        data: formData
    })
}
